import { render, staticRenderFns } from "./Paso2.vue?vue&type=template&id=f7f910ca&lang=pug&"
import script from "./Paso2.vue?vue&type=script&lang=js&"
export * from "./Paso2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports